import React from 'react';
import { useGenGridCol } from '../../../../../utils/ComponentHelper';
import { displayAmountCurrying } from '../../../../../utils';
import { useTranslation } from '../../../../../hooks';
import {
  ExactPayExecutionDetail,
  ExecutionType,
  Operation,
} from '../types/OperationDetailsRequestBody';
import { getSwapPathDisplay } from '../utils/getSwapPathDisplay';
import { TransactionOperation } from '../../types/GetListRes';

interface IProps {
  transactionOperations: TransactionOperation[];
}

type ExactPayExecutionDetailWithMeta = ExactPayExecutionDetail & {
  operation_seq?: string;
  batch_id?: string;
};

const useSwapDetailsExactPayTable = ({ transactionOperations }: IProps) => {
  const { translate } = useTranslation();

  // Exact Pay
  const exactPayColumns = [
    // useGenGridCol('operationSequence', {
    //   minWidth: 140,
    // }),
    // useGenGridCol('batchId', {
    //   minWidth: 140,
    // }),
    // useGenGridCol('toAddress', {
    //   minWidth: 350,
    // }),
    useGenGridCol('executionType', {
      minWidth: 250,
    }),
    useGenGridCol('exactPayAmount', {
      minWidth: 140,
    }),
    useGenGridCol('minGetAmount', {
      minWidth: 140,
    }),

    useGenGridCol('swapPath', {
      minWidth: 250,
    }),
  ];

  const createExecutionDetailsArray = (transactionOperations: TransactionOperation[]) => {
    const executionDetails = transactionOperations.map((operation) => {
      return {
        operation_seq: operation?.operationSeq,
        batch_id: operation?.batchId,
        ...JSON.parse(operation?.executionDetail || '{}'),
      };
    });

    return executionDetails as ExactPayExecutionDetailWithMeta[];
  };

  const executionDetails = createExecutionDetailsArray(transactionOperations);

  const exactPayRows = executionDetails
    ?.map((executionDetail: ExactPayExecutionDetailWithMeta, index: number) => {
      const toMinGetDisplayAmount = displayAmountCurrying(executionDetail?.decimals_get || '');
      const toExactPayDisplayAmount = displayAmountCurrying(executionDetail?.decimals || '');

      const swapPathDisplay = getSwapPathDisplay(executionDetail?.swap_path || []);

      return {
        id: index,
        operationSequence: executionDetail.operation_seq || '',
        batchId: executionDetail.batch_id || '',
        toAddress: executionDetail?.to_address || '',
        executionType:
          translate(`enumConstants.${ExecutionType[executionDetail?.execution_type]}`) || '',
        exactPayAmount: `${toExactPayDisplayAmount(executionDetail?.amount || '')} ${
          executionDetail?.asset_name || ''
        }`,
        minGetAmount: `${toMinGetDisplayAmount(executionDetail?.amount_get_min || '')} ${
          executionDetail?.asset_name_get || ''
        }`,

        swapPath: swapPathDisplay,
      };
    })
    ?.sort((a, b) => {
      // sort by operation sequence in ascending order
      const operationSeqA = Number(a.operationSequence);
      const operationSeqB = Number(b.operationSequence);

      return operationSeqA - operationSeqB;
    });

  return { exactPayColumns, exactPayRows };
};

export default useSwapDetailsExactPayTable;
